var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove"},[_vm._m(0),_c('div',{staticClass:"remove-table"},[_c('Table',{attrs:{"head":_vm.removeOrderTableHead,"width":"1654","height":"550"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove-top"},[_c('div',{staticClass:"remove-top__name"},[_vm._v("移除单")])])
}]

export { render, staticRenderFns }